"use strict";

require("core-js/modules/es.array.flat-map");

require("core-js/modules/es.array.unscopables.flat-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flattenColorPalette;

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function flattenColorPalette(colors) {
  var result = (0, _lodash.default)(colors).flatMap(function (color, name) {
    if (!_lodash.default.isObject(color)) {
      return [[name, color]];
    }

    return _lodash.default.map(color, function (value, key) {
      var suffix = key === 'default' ? '' : "-".concat(key);
      return ["".concat(name).concat(suffix), value];
    });
  }).fromPairs().value();
  return result;
}